import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Button, Input, InputMasks, TextErrorInput, showToast } from '@provi/provi-components'
import { validateText, validateState } from '../../../utils/validators'
import { Form } from '../../../components/form'
import { useCepValidator } from './hooks'

export const Formik = props => {
  const {
    handleChange,
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    setFieldValue,
    setIsLoading,
    data,
    setDataModal
  } = props
  const [isShowAddress, getCep, addInput, inputRefs] = useCepValidator(data, setDataModal)

  const handleCepChange = async e => {
    if (!e) return false
    const { value } = e.target
    const _zipcode = value && value.replace(/[^\d]+/g, '')
    setFieldValue('zipcode', _zipcode)

    if (_zipcode && _zipcode.length === 8) {
      setIsLoading(true)
      try {
        const address = await getCep(_zipcode)
        setFieldValue('zipcode', address.zipcode)
        setFieldValue('city', address.city)
        setFieldValue('state', address.state)
        setFieldValue('district', address.district)
        setFieldValue('street', address.street)
        inputRefs && inputRefs[0] && inputRefs[0].focus()
        return true
      } catch (err) {
        if (err && err.message === 'Todos os serviços de CEP retornaram erro.') showToast('Nenhum cep foi encontrado')
        return false
      } finally {
        setIsLoading(false)
      }
    }
    return false
  }

  return (
    <Form onSubmit={handleSubmit}>
      <InputMasks
        id="zipcode"
        type="tel"
        InputProps={{ 'aria-label': 'zipcode' }}
        mask="99999-999"
        placeholder="Ex: 04548-004"
        autoFocus={!values.zipcode}
        value={values.zipcode}
        onChange={e => handleCepChange(e)}
      />
      {errors.zipcode && touched.zipcode && <TextErrorInput text={errors.zipcode} />}

      {isShowAddress && (
        <>
          <Input
            id="state"
            inputProps={{ 'aria-label': 'uf', maxLength: 2 }}
            value={values.state}
            placeholder="UF"
            onBlur={handleBlur('state')}
            onChange={handleChange('state')}
            style={{ textTransform: 'uppercase' }}
          />
          {errors.state && <TextErrorInput text={errors.state} />}

          <Input
            id="city"
            inputProps={{ 'aria-label': 'city' }}
            onBlur={handleBlur('city')}
            onChange={handleChange('city')}
            placeholder="Cidade"
            value={values.city}
          />
          {errors.city && touched.city && <TextErrorInput text={errors.city} />}

          <Input
            id="district"
            inputProps={{ 'aria-label': 'district' }}
            placeholder="Bairro"
            onBlur={handleBlur('district')}
            onChange={handleChange('district')}
            value={values.district}
          />
          {errors.district && touched.district && <TextErrorInput text={errors.district} />}

          <Input
            id="street"
            inputProps={{ 'aria-label': 'street' }}
            placeholder="Endereço"
            onBlur={handleBlur('street')}
            onChange={handleChange('street')}
            value={values.street}
          />
          {errors.street && touched.street && <TextErrorInput text={errors.street} />}

          <Input
            id="number"
            inputProps={{ 'aria-label': 'number', ref: addInput }}
            onBlur={handleBlur('number')}
            onChange={handleChange('number')}
            placeholder="Número"
            value={values.number}
          />
          {errors.number && touched.number && <TextErrorInput text={errors.number} />}

          <Input
            id="complement"
            inputProps={{ 'aria-label': 'complement' }}
            placeholder="Complemento (opcional)"
            onBlur={handleBlur('complement')}
            onChange={handleChange('complement')}
            value={values.complement}
          />
        </>
      )}

      <Button
        marginHorizontal={0}
        marginVertical={24}
        type="submit"
        disabled={
          !(values.zipcode && values.city && values.state && values.district && values.street && values.number) ||
          errors.zipcode ||
          errors.city ||
          errors.state ||
          errors.district ||
          errors.street ||
          errors.number
        }
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFormik = withFormik({
  validateOnChange: true,
  mapPropsToValues: props => {
    const { data } = props
    return {
      zipcode: data && data.zipcode ? data.zipcode : '',
      city: data && data.city ? data.city : '',
      state: data && data.state ? data.state : '',
      district: data && data.district ? data.district : '',
      street: data && data.street ? data.street : '',
      number: data && data.number ? data.number : '',
      complement: data && data.complement ? data.complement : ''
    }
  },
  validationSchema: () =>
    Yup.object().shape({
      city: Yup.string()
        .required('Digite uma cidade')
        .test({
          name: 'city',
          message: 'Cidade inválida',
          test: city => city && validateText(city)
        }),
      state: Yup.string()
        .required('Digite um estado')
        .test({
          name: 'state',
          message: 'Estado inválido',
          test: state => state && validateState(state)
        }),
      district: Yup.string().required('Digite um bairro'),
      street: Yup.string().required('Digite um endereço'),
      number: Yup.string().required('Digite um número')
    }),
  handleSubmit: async (values, { props }) => {
    const { setIsLoading, goToNextScreen } = props

    try {
      setIsLoading(true)
      goToNextScreen(values)
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
        showToast(error.response.data.error.message)
        return false
      }
      showToast()
      setIsLoading(false)
    }
  }
})(Formik)
